import {
    GET_LIST_PHIKHACHANGKY,
    GET_LIST_PHIKHACHANGKY_SUCCESS,
    GET_LIST_PHIKHACHANGKY_FAILURE,
    GET_LIST_PHIKHACHANGKY_CHOVAY,
    GET_LIST_PHIKHACHANGKY_CHOVAY_SUCCESS,
    GET_LIST_PHIKHACHANGKY_CHOVAY_FAILURE,
  } from "actions/PhiKhacHangKy/actionTypes";
  
  const initialState = {
    getListPhiKhacHangKyLoading: false,
    phiKhacHangKyFetched: false,
    objListPhiKhacHangKy: [],
    totalRow: 0,
    objChoVay_PhiKhacHangKy: [],
  };
  
  const getListPhiKhacHangKy = (state, action) => ({
    ...state,
    getListPhiKhacHangKyLoading: true,
    phiKhacHangKyFetched: true,
  });
  
  const getListPhiKhacHangKySuccess = (state, action) => {
    return {
      ...state,
      getListPhiKhacHangKyLoading: false,
      objListPhiKhacHangKy: action.payload,
      phiKhacHangKyFetched: true,
    };
  };
  
  const getListPhiKhacHangKyFailed = (state, action) => ({
    ...state,
    getListPhiKhacHangKyLoading: false,
    objListPhiKhacHangKy: [],
    phiKhacHangKyFetched: true,
  });
  
  const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_LIST_PHIKHACHANGKY:
        return getListPhiKhacHangKy(state, action);
      case GET_LIST_PHIKHACHANGKY_SUCCESS:
        return getListPhiKhacHangKySuccess(state, action);
      case GET_LIST_PHIKHACHANGKY_FAILURE:
        return getListPhiKhacHangKyFailed(state, action);
      case GET_LIST_PHIKHACHANGKY_CHOVAY:
        return getListPhiKhacHangKy(state, action);
      case GET_LIST_PHIKHACHANGKY_CHOVAY_SUCCESS:
        return getListPhiKhacHangKySuccess(state, action);
      case GET_LIST_PHIKHACHANGKY_CHOVAY_FAILURE:
        return getListPhiKhacHangKyFailed(state, action);
      default:
        return state;
    }
  };
  
  export default authReducer;
  